<template>
    <div>
        <div class="page page-office d-flex" id="office">
                <page-header class="office-header"/>
                <side-nav class="office-side-nav"/>
            <div class="w-100 office-content">
                <!-- Medium width and larger screens -->
                <div class="d-none d-md-block office-map">
                    <img class="bitmap" src="../../static/images/Livio_Office_Map.png"/>
                    <img class="office-focus" src="../../static/images/our-office.png"/>
                </div>
                <!-- Smaller width screens -->
                <div class="col-12 d-md-none d-sm-block d-xs-none small-office-map">
                    <img class="small-bitmap w-100 highlight" src="../../static/images/Livio_Office_Map_small.png"/>
                    <img class="small-office-focus" src="../../static/images/our-office.png"/>
                </div>
            </div>
        </div>
        <div class="d-none d-sm-block d-md-none office-spacer"></div>
        <page-footer class="d-md-none small-office-footer"></page-footer>
        <!-- This footer can't simply be imported because it needs to align with the left of the map -->
        <div class="d-none d-md-block office-footer footer">
            <div class="page-content">
                <div class="office-footer-container container">
                    <div class="row align-items-top">
                        <div class="col-sm-3 text-left mb-4">
                            <p>1.248.591.0333</p>
                            <p><a href="mailto:info@livio.io">info@livio.io</a></p>
                        </div>
                        <div class="col-sm-3 text-left mb-4">
                            <p>332 E Lincoln Ave.</p>
                            <p>Royal Oak, MI 48067</p>
                        </div>
                        <div class="col-sm-3 text-left mb-4">
                            <p>© 2022 Livio. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Header from './shared/Header.vue'
import Footer from './shared/Footer.vue'
import SideNav from './shared/SideNav.vue'
export default {
    data () {
        return {
        }
    },
    components: {
        "page-footer": Footer,
        "page-header": Header,
        "side-nav": SideNav,
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Office.vue